import React, { ReactNode } from 'react'
import styles from './ImageLayout.module.css'

interface ImageLayoutProps {
  imagePath: string
  imagePosition: string
  children: ReactNode | ReactNode[]
}

export const ImageLayout: React.FC<ImageLayoutProps> = ({
  children,
  imagePosition = 'right',
  imagePath,
}) => {
  return (
    <div className="archetypeHeader">
      <div className={`${styles.container} ${styles[imagePosition]}`}>
        <div className={styles.content}>{children}</div>
        <div className={styles.imageWrapper}>
          <img src={imagePath} alt={imagePath} />
        </div>
      </div>
    </div>
  )
}
